/* Evora — vídeos UGC (compartido por «Vídeos UGC» y «UGC compacto»). Antes vivía dentro de sections/ugc-videos.liquid. */
(function () {
  var W = (window.EvoraUGC = window.EvoraUGC || {});

  if (!W.init) {
    W.init = function (root) {
      if (!root || root.hasAttribute('data-ugc-ready')) return;
      root.setAttribute('data-ugc-ready', '');
      var autoplay = root.getAttribute('data-autoplay') !== 'false';
      var vids = [];
      root._ugcManual = false;

      function start(v) {
        v._userPaused = false;
        root._ugcActive = v;
        vids.forEach(function (o) { if (o !== v && !o.paused) o.pause(); });
if (!v.muted) document.querySelectorAll('[data-evora-ugc-section] video').forEach(function (o) { if (o !== v && !o.muted) o.muted = true; });
        if (v.preload !== 'auto') v.preload = 'auto';
        var p = v.play();
        if (p && p.catch) p.catch(function () {
          if (!v.muted) { v.muted = true; v.play().catch(function () {}); }
        });
      }

      root.querySelectorAll('[data-ugc]').forEach(function (card) {
        var v = card.querySelector('video');
        if (!v) return;
        vids.push(v);
        v.muted = true; v.defaultMuted = true; v.loop = true; v.controls = false;
        v.playsInline = true; v.setAttribute('playsinline', ''); v.setAttribute('webkit-playsinline', '');
        var pb = card.querySelector('[data-ugc-play]');
        var sb = card.querySelector('[data-ugc-sound]');

        function sync() {
          var on = !v.paused && !v.ended;
          var snd = !v.muted;
          card.classList.toggle('is-playing', on);
          if (pb) {
            pb.setAttribute('aria-pressed', on ? 'true' : 'false');
            pb.setAttribute('aria-label', on ? 'Pausar vídeo' : 'Reproducir vídeo');
            pb.querySelector('[data-icon-play]').hidden = on;
            pb.querySelector('[data-icon-pause]').hidden = !on;
          }
          if (sb) {
            sb.setAttribute('aria-pressed', snd ? 'true' : 'false');
            sb.setAttribute('aria-label', snd ? 'Silenciar vídeo' : 'Activar sonido');
            sb.querySelector('[data-icon-off]').hidden = snd;
            sb.querySelector('[data-icon-on]').hidden = !snd;
          }
        }
        ['play', 'playing', 'pause', 'ended', 'volumechange'].forEach(function (ev) { v.addEventListener(ev, sync); });
        sync();

        function toggle() {
          root._ugcManual = true;
          if (v.paused) start(v);
          else { v._userPaused = true; v.pause(); }
        }
        if (pb) pb.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); toggle(); });
        card.addEventListener('click', function (e) { if (e.target.closest('button, a')) return; toggle(); });
        if (sb) sb.addEventListener('click', function (e) {
          e.preventDefault(); e.stopPropagation();
          root._ugcManual = true;
          if (v.muted) {
            document.querySelectorAll('[data-evora-ugc-section] video').forEach(function (o) { if (o !== v) o.muted = true; });
            v.muted = false; v.volume = 1;
            start(v);
          } else {
            v.muted = true;
          }
        });
      });

      if (!vids.length) return;

      if ('IntersectionObserver' in window) {
        var near = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            if (en.isIntersecting && en.target.preload === 'none') en.target.preload = 'metadata';
          });
        }, { rootMargin: '300px' });
        var view = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            var v = en.target;
            if (en.intersectionRatio >= 0.6) {
              if (v._userPaused) return;
              if (!root._ugcManual && autoplay) { if (v.preload !== 'auto') v.preload = 'auto'; v.play().catch(function () {}); }
              else if (root._ugcManual && root._ugcActive === v && v.paused) v.play().catch(function () {});
            } else if (en.intersectionRatio < 0.25 && !v.paused) {
              v.pause();
            }
          });
        }, { threshold: [0, 0.25, 0.6, 1] });
        vids.forEach(function (v) { near.observe(v); view.observe(v); });
        root._ugcObservers = [near, view];
      }
    };

    W.destroy = function (root) {
      if (!root) return;
      (root._ugcObservers || []).forEach(function (o) { o.disconnect(); });
      root.querySelectorAll('video').forEach(function (v) { v.pause(); });
    };

    document.addEventListener('shopify:section:load', function (e) {
      e.target.querySelectorAll('[data-evora-ugc-section]').forEach(W.init);
      if (window.Evora && window.Evora.initSliders) window.Evora.initSliders(e.target);
    });
    document.addEventListener('shopify:section:unload', function (e) {
      e.target.querySelectorAll('[data-evora-ugc-section]').forEach(W.destroy);
    });
    document.addEventListener('shopify:block:select', function (e) {
      var card = e.target.closest && e.target.closest('[data-ugc-card]');
      var track = card && card.closest('[data-slider-track]');
      if (track) track.scrollTo({ left: card.offsetLeft - track.offsetLeft - parseFloat(getComputedStyle(track).paddingLeft || 0), behavior: 'smooth' });
    });
  }

  var run = function () { document.querySelectorAll('[data-evora-ugc-section]').forEach(W.init); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
